// @systeme: interface
// « Qui fait quoi » : les tâches attribuées, par personne. Pas de total, pas de
// pourcentage, pas de comparaison (DEC-009). L'écran n'est accessible que s'il y a
// au moins une tâche attribuée.
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { ChevronLeft } from 'lucide-react';
import { Link as LienRouteur } from 'react-router';
import type { VueRepartition } from '@foyer/shared';
import { Chargement } from '../composants/Chargement';
import { useMessages } from '../composants/Messages';
import { api } from '../lib/api';
import { formaterJourCourt, jourDe } from '../lib/dates';
import { couleurs, tailles } from '../theme/theme';

export function QuiFaitQuoi() {
  const { direErreur } = useMessages();
  const [vue, setVue] = useState<VueRepartition | undefined>();

  useEffect(() => {
    api.elements.repartition().then(setVue).catch(direErreur);
  }, [direErreur]);

  if (!vue) return <Chargement />;

  return (
    <Box sx={{ px: `${tailles.marge}px`, pt: 3 }}>
      <Button
        component={LienRouteur}
        to="/moi"
        startIcon={<ChevronLeft size={18} />}
        color="inherit"
        sx={{ px: 0, mb: 1 }}
      >
        Moi
      </Button>
      <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
        Qui fait quoi
      </Typography>
      {vue.parMembre.length === 0 ? (
        <Typography color="text.secondary">Aucune tâche n’est attribuée pour le moment.</Typography>
      ) : (
        vue.parMembre.map(({ membre, elements }) => (
          <Box key={membre.id} sx={{ mb: 3 }}>
            <Typography variant="h2" component="h2" sx={{ mb: 1 }}>
              {membre.prenom}
            </Typography>
            <List disablePadding aria-label={membre.prenom}>
              {elements.map((e) => (
                <ListItem
                  key={e.id}
                  sx={{
                    bgcolor: couleurs.blanc,
                    borderRadius: `${tailles.rayon}px`,
                    mb: 1,
                    border: 1,
                    borderColor: 'divider',
                  }}
                >
                  <ListItemText
                    primary={e.titre}
                    secondary={e.debutLe ? formaterJourCourt(jourDe(e.debutLe)) : undefined}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        ))
      )}
    </Box>
  );
}
